exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":root{--font-sans:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Helvetica,Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";--font-mono:\"Roboto Mono\",\"SFMono-Regular\",Consolas,\"Liberation Mono\",Menlo,Courier,monospace;--yellow:#ff0;--cyan:#45ffff;--magenta:#ff3dff;--green:#0f0;--dark-blue:#1900c1;--lime-green:#b2ff59;--green:#00e676;--red:#ff5f50;--color:#eceefa;--muted:#636773;--bg-color:#222;--border-color:var(--muted);--link-color:var(--yellow);--select-color:var(--bg-color);--select-bg-color:var(--yellow);--caret-color:var(--yellow);--preview-color:var(--color);--header-height:64px;--info-control-height:24px;--info-control-width:36px;--gutter:8px}@media (min-width:640px){:root{--gutter:16px;--header-height:96px}}*{box-sizing:border-box}::selection{color:var(--select-color);background-color:var(--select-bg-color)}a{color:var(--link-color)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-427a9fc7!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 9
// module chunks = 0